import React from 'react';
import styled from 'styled-components';

import Text from '../../Text';
import RadioInput from '../../RadioInput';

const RadioButtonForm = ({
  title,
  name,
  handleChange,
  currentValue,
  radioOptions = [],
}) => {
  return (
    <Wrapper>
      <Text variant="h7">{title}</Text>
      <RadioContainer>
        {radioOptions.map(({ value, label }) => (
          <RadioInput
            name={name}
            label={label}
            value={value}
            key={label}
            id={label}
            onChange={handleChange}
            checked={value == currentValue}
          />
        ))}
      </RadioContainer>
    </Wrapper>
  );
};

export default RadioButtonForm;

const Wrapper = styled.div`
  padding: 16px 0;
`;

const RadioContainer = styled.div`
  display: flex;
  margin: 0 0 21px;
  flex-wrap: wrap;

  > div {
    margin: 16px 24px 0 0;
  }
`;
